import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

const SellerInfo = ({ children }) => (<div className="gig-seller-info">{children}</div>);

SellerInfo.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.element])),
        PropTypes.element
    ])
};

export default SellerInfo;



// WEBPACK FOOTER //
// ./src/shared/seller_info/index.js